import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { accessLevel } from '@/auth/access';

export default function AdminOnly({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  return accessLevel(user) === 'admin' ? children : <Navigate to="/" replace />;
}
